module.exports = __webpack_public_path__ + "static/media/cowinEdit.bd5af02c.svg";